import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CarButton from "./CarButton";

const BlogCard = ({ img, text, buttonText, buttonTo, buttonClass, permalink }) => {

  const urlPermalink = '/news-ed-eventi/'+permalink;
  return (
    <div className="card shadow-sm d-flex flex-column" style={{ maxWidth: "100%",  height: "100%", padding:"10px" }}>
      {/* Immagine */}
      <a href={urlPermalink}>
        <img
        src={img}
        alt="Blog"
        className="card-img-top"
        style={{
          maxWidth: "420px",
          
        }}
      />

      {/* Corpo della Card */}
      <div className="card-body d-flex flex-column justify-content-between">
        {/* Testo */}
        <p className="text-dark card-text fs-6 fw-normal ">{text}</p>

        {/* Pulsante */}
        <div className="d-flex">
          <CarButton
            text={buttonText}
            to={urlPermalink}
            customClass={`btn ${buttonClass}`}
          />
        </div>
      </div>
      </a>
    </div>
  );
};

export default BlogCard;
